module.exports = __webpack_public_path__ + "images/unit-icons/10x15-storage.svg";